import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import RequirementDetailSection from "../sections/RequirementDetailSection";

interface Props {
  id: string;
}

const RequirementDetail = (props: Props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  
  const { id } = useParams<Props>();

  return (
    <>
      <Header
        title={t("requirementDetail.title")}
        includeBreadcrumbs
        links={[{ text: t("requirements.title"), to: "/requirements" }]}
      />
      <ModuleContent>
        <RequirementDetailSection requirementId={id} />
      </ModuleContent>
    </>
  );
};

export default RequirementDetail;
